import type { Geolocation } from "@/lib/geolocation"
import {
  distanceKeyToOption,
  distanceOptionToKey,
} from "@/lib/geolocation/distance/distance"
import { isDistanceKey } from "@/lib/geolocation/distance/isKey"

export const parseDistance = (
  distanceKeyOrOption: Geolocation.DistanceKey | Geolocation.DistanceOption
): {
  distanceKey: Geolocation.DistanceKey
  distanceOption: Geolocation.DistanceOption
} => {
  if (isDistanceKey(distanceKeyOrOption)) {
    return {
      distanceKey: distanceKeyOrOption,
      distanceOption: distanceKeyToOption(distanceKeyOrOption),
    }
  }

  return {
    distanceKey: distanceOptionToKey(distanceKeyOrOption),
    distanceOption: distanceKeyOrOption,
  }
}
